/**
 * OC Loading Message Component
 * Shows avatar/icon with loading ellipsis during chat initialization
 */

import { FC } from 'react';

import { AiIcon } from '../AiIcon/AiIcon';
import { LoadingEllipsis } from '../Message/LoadingEllipsis';
import { AILoadingMessageContainer } from './AILoadingMessage.styled';
import { Avatar,AvatarContainer } from './AiMessageHeader.styled';

export interface AILoadingMessageProps {
  /** Name of the AI assistant */
  assistantName: string;
  /** Optional custom avatar URL */
  avatarUrl?: string;
}

/**
 * OCAILoadingMessage Component
 * 
 * Displays during initial chat loading state, showing the AI assistant's
 * avatar (or sparkle icon fallback) with animated loading ellipsis.
 * 
 * @example
 * ```tsx
 * <OCAILoadingMessage 
 *   assistantName="Community Assistant"
 *   avatarUrl="https://example.com/avatar.png"
 * />
 * ```
 */
export const AILoadingMessage: FC<AILoadingMessageProps> = ({
  assistantName,
  avatarUrl,
}) => {
  return (
    <AILoadingMessageContainer>
      <AvatarContainer>
      {/* Avatar or sparkle icon */}
      {avatarUrl ? (
        <Avatar src={avatarUrl} alt={assistantName} />
      ) : (
        <AiIcon height={18} />
      )}
      </AvatarContainer>  
      <LoadingEllipsis />
    </AILoadingMessageContainer>
  );
};

export default AILoadingMessage;

